module.exports = __webpack_public_path__ + "fonts/visuelt-pro-medium.027a8d3b.woff2";